// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 17:57:10

export default {
  "id": "car-parking-stunt-games-2024",
  "slug": "car-parking-stunt-games-2024",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/74e90bea3b05469dae2f2efe2027ced8-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/74e90bea3b05469dae2f2efe2027ced8/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Car Parking Stunt Games 2024",
      "description": "Play the new challenging car game on Impossible Tracks in car stunt games 3d of 2024. Join the world of real impossible tracks in car racing games. Experience the real car parking stunt game with no limits of enjoyment. Are you a fan of Hard Parking Games 2024.",
      "instructions": "Use W,A,S,D for player movement.",
      "genres": [
        "Racing & Driving",
        "Simulation"
      ],
      "tags": [
        "car",
        "parking",
        "stunts",
        "track"
      ]
    },
    "zh-CN": {
      "title": "2024停车场特技游戏",
      "description": "在2024年的《汽车特技游戏3D》中玩新挑战性的赛车游戏《不可能赛道》。加入真实不可能赛道汽车竞速游戏的世界。体验无限制乐趣的真实汽车停车特技游戏。你是《2024年硬停车游戏》的粉丝吗？",
      "instructions": "使用W、A、S、D键进行玩家移动。",
      "genres": [
        "赛车与驾驶",
        "模拟"
      ],
      "tags": [
        "汽车",
        "停车",
        "特技",
        "赛道"
      ]
    },
    "zh-TW": {
      "title": "停車場特技遊戲 2024",
      "description": "在2024年的《不可能道路》挑戰賽車遊戲中玩遊戲，加入真實不可能道路的賽車遊戲世界。體驗沒有限制的真實停車特技遊戲。你是《2024年硬停車遊戲》的粉絲嗎？",
      "instructions": "使用W,A,S,D鍵進行玩家移動。",
      "genres": [
        "賽車與駕駛",
        "模擬"
      ],
      "tags": [
        "車輛",
        "停車",
        "特技",
        "賽道"
      ]
    },
    "zh-HK": {
      "title": "停車場駕駛特技遊戲 2024",
      "description": "玩2024年的全新挑戰車輛遊戲，於《不可能軌道》車技遊戲3D。加入真實不可能軌道的賽車遊戲世界。體驗無限樂趣的真實車位停泊挑戰遊戲。你是2024年《硬停車遊戲》的粉絲嗎？",
      "instructions": "使用 W,A,S,D 鍵進行玩家移動。",
      "genres": [
        "賽車及駕駛",
        "模擬"
      ],
      "tags": [
        "車輛",
        "停車",
        "特技",
        "賽道"
      ]
    },
    "ja": {
      "title": "2024 カーセッティングスタントゲーム",
      "description": "2024年の「Impossible Tracks」で挑戦的な車ゲームを遊んでください。車のスタントゲーム3Dの「Car Stunt Games 3D」に参加して、本物の不可能なトラックの世界に飛び込みましょう。制限なく楽しむ本物の車の駐車スタントゲームを体験してください。2024年の「Hard Parking Games」のファンですか？",
      "instructions": "W,A,S,Dを使用してプレイヤーの移動を行ってください。",
      "genres": [
        "レーシング & ドライビング",
        "シミュレーション"
      ],
      "tags": [
        "車",
        "駐車",
        "スタント",
        "トラック"
      ]
    },
    "ko": {
      "title": "카를 주차 스타운트 게임 2024",
      "description": "2024년의 3D 카 레이싱 게임 'Impossible Tracks'에서 새로운 도전적인 자동차 게임을 즐겨보세요. 실제 불가능한 트랙의 세계에 참여해 보세요. 즐거움의 한계 없는 실제 차 주차 스타일 게임을 경험해 보세요. 2024년 'Hard Parking Games'의 팬이신가요?",
      "instructions": "W,A,S,D 키를 사용하여 플레이어 이동을 하세요.",
      "genres": [
        "레이싱 & 드라이빙",
        "시뮬레이션"
      ],
      "tags": [
        "차량",
        "주차",
        "스탠트",
        "트랙"
      ]
    },
    "fr": {
      "title": "Jeux de parking en stunts 2024",
      "description": "Jouez au nouveau jeu de course automobile défiant sur Impossible Tracks dans Car Stunt Games 3d de 2024. Rejoignez le monde des pistes impossibles réelles dans les jeux de course automobile. Profitez du jeu de parking de stunt en voiture sans limites de plaisir. Êtes-vous fan des Jeux de Parking Difficiles 2024 ?",
      "instructions": "Utilisez les touches W, A, S, D pour le déplacement du joueur.",
      "genres": [
        "Courses & Conduite",
        "Simulation"
      ],
      "tags": [
        "voiture",
        "stationnement",
        "figures d'acrobatie",
        "piste"
      ]
    }
  }
};
